import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { TEN_SECONDS } from '../../lib/constants';
import PaymentStatus from '../../screens/PaymentScreen/PaymentStatus/PaymentStatus';
import BalancePaymentCompleteView from './BalancePaymentCompleteView';
import { BalancePaymentState } from '../../hooks/cart/useBalancePaymentRequest';

export interface BalancePaymentOverlayProps {
  state: BalancePaymentState;
  onDismiss: () => void;
}

/**
 * Account balance payments have no order, so they cannot use the cart-driven
 * PaymentScreen. Rendered as an overlay above the cart navigator instead.
 */
const BalancePaymentOverlay: React.FC<BalancePaymentOverlayProps> = ({
  state,
  onDismiss,
}) => {
  const { status, amount } = state;
  const isSettled = status === 'complete' || status === 'error';

  useEffect(() => {
    if (!isSettled) return;
    const timeoutId = setTimeout(onDismiss, TEN_SECONDS);
    return () => clearTimeout(timeoutId);
  }, [isSettled, onDismiss]);

  if (status === 'idle') return null;

  return (
    <View style={styles.overlay}>
      {status === 'complete' ? (
        <BalancePaymentCompleteView amount={amount} />
      ) : (
        <PaymentStatus
          status={status === 'error' ? 'error' : 'processing'}
          amountDue={amount}
          onDismiss={onDismiss}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFill,
    zIndex: 10,
  },
});

export default BalancePaymentOverlay;
